module.exports = __webpack_public_path__ + "static/media/Text.a812ed47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/reusable/images/Text.svg
// module id = 960
// module chunks = 0